/** @file Rounds committed values (R-E1-06): 4 decimals by default, 2 for image pixels. */

/** Rounds to `digits` decimals; -0 becomes 0 (a key stored as -0 would make round trips write, ledger T-235 N-6). */
export function roundValue(v: number, digits = 4): number {
  const k = 10 ** digits;
  return Math.round(v * k) / k + 0;
}
